import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { CityProvider } from "./hooks/useCityContext";
import ForSaleBadge from "./components/feature/ForSaleBadge";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <CityProvider>
        <AppRoutes />
        <ForSaleBadge />
      </CityProvider>
    </BrowserRouter>
  );
}

export default App;
